import { useEffect } from 'react';
import { Layout } from './Layout';

export type ProtectedRouteProps = {
    Component: any,
    title: string,
};

export default function LayoutRouter({ Component, title }: ProtectedRouteProps) {

    useEffect(() => {
        document.title = title;
    }, [])
    
    return (

        <Layout title={title}>
            <Component />
        </Layout>
    )

};